import { axiosObjectTypesense } from "../typesenseConfig";

function getSearchResults(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `multi_search?x-typesense-api-key=${process.env.NEXT_PUBLIC_SEARCH_KEY}`;

    axiosObjectTypesense
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

function getPrivatePropertySearchResults(payload: any) {
  return new Promise((resolve, reject) => {
    let uri = `multi_search?x-typesense-api-key=${process.env.NEXT_PUBLIC_PRIVATE_PROPERTY_SEARCH_KEY}`;

    axiosObjectTypesense
      .post(uri, payload)
      .then((response) => {
        resolve(response.data);
      })
      .catch((errors) => {
        reject(errors);
      });
  });
}

export { getPrivatePropertySearchResults, getSearchResults };
